import history from "../config/history";
import { openSignUpModal, openPaymentIssueModal } from "./generalActions";
import { signOut } from "./userActions";

export const errorHandler = async (
  type,
  error,
  reduxOnly = false,
  dispatch,
  callback
) => {
  let payload = "Something went wrong.";

  if (reduxOnly) {
    payload =
      error?.response && error?.response.data
        ? error.response.data.error
        : error.message;
    dispatch({
      type,
      payload,
    });
    if (callback) await callback(type, payload);
    return;
  }

  if (
    typeof error == "string" ||
    !error?.response ||
    !error?.response?.data?.error
  ) {
    payload = "Some error occured, please try again";
    dispatch({
      type,
      payload,
    });
  } else {
    const errorResponse = error.response.data.error;

    if (errorResponse === "jwt expired") {
      if (type === "USER_ACTIVATION_FAIL") {
        payload = "The Activation link as expired, please register again";
        await dispatch({
          type,
          payload,
        });
      } else if (type == "USER_LOGGEDIN_CHECK_FAIL") {
        payload = "Your login session has expired, Please login again";
        dispatch({
          type,
          payload,
        });
      } else {
        payload = "Your login session has expired, Please login again";
        dispatch({
          type,
          payload,
        });
        signOut(false)(dispatch);
        openSignUpModal()(dispatch);
      }
    } else if (errorResponse === "jwt malformed") {
      if (type === "USER_ACTIVATION_FAIL") {
        payload = "The Activation link is invalid, please register again";
        await dispatch({
          type,
          payload,
        });
      } else if (type == "USER_LOGGEDIN_CHECK_FAIL") {
        payload = "Your login session has expired, Please login again";
        dispatch({
          type,
          payload,
        });
      } else {
        payload = "Your login session has expired, Please login again";
        dispatch({
          type,
          payload,
        });
        signOut(false)(dispatch);
        openSignUpModal()(dispatch);
      }
    } else if (errorResponse === "No authorisation token found") {
      if (type === "USER_ACTIVATION_FAIL") {
        payload = "The Activation link is invalid, please register again";
        await dispatch({
          type,
          payload,
        });
        if (callback) await callback(type, payload);
        return;
      } else if (type == "USER_LOGGEDIN_CHECK_FAIL") {
        payload = "Your login session has expired, Please login again";
        dispatch({
          type,
          payload,
        });
      } else {
        payload = "Please login/register to perform this action";
        dispatch({
          type,
          payload,
        });
        signOut(false)(dispatch);
        openSignUpModal()(dispatch);
      }
    } else if (
      errorResponse === "The video specified was not found" ||
      errorResponse === "The video is not available now"
    ) {
      payload = errorResponse;
      await dispatch({
        type,
        payload: errorResponse,
      });
      history.go(0);
    } else if (errorResponse === "This video cannot be saved to watchlist") {
      payload = errorResponse;
      await dispatch({
        type,
        payload: errorResponse,
      });
    } else if (errorResponse === "Video already in watched today") {
      dispatch({ type });
    } else if (errorResponse === "This user is already a premium member!") {
      payload =
        "You are currently a premium member, as long as auto renewal is turned on in your settings, your account will be charged for for every month automatically";
      dispatch({
        type,
        payload,
      });
    } else if (
      errorResponse === "Sorry you cannot access this, this is premium content"
    ) {
      payload =
        "This is premium content, subscribe to MeenduToons to gain access to this content!";
      dispatch({
        type,
        payload,
      });
      history.push("/pricing");
    } else if (
      errorResponse === "Sorry you cannot access this, premium content" ||
      errorResponse === "Sorry you cannot access this, admin content"
    ) {

      if(type === "VIDEO_WATCHED_FAIL"){
        return;
      }

      payload = errorResponse;
      dispatch({ type, payload });
      history.push("/");
    } else if (errorResponse === "Duplicate field value entered") {
      payload =
        "Another account exists with the data you entered, please try again";
      dispatch({
        type,
        payload,
      });
    } else if (errorResponse === "User not found") {
      payload = "The user account does not exists";
      await dispatch({
        type,
        payload,
      });

      if (!history.location.pathname.includes("pwdReset")) {
        signOut(false)(dispatch);
        openSignUpModal()(dispatch);
      }
    } else if (
      errorResponse == "No password reset token or userId found" ||
      errorResponse == "Password reset token not found" ||
      errorResponse == "User ID not found"
    ) {
      payload = "Invalid password reset link";
      await dispatch({
        type,
        payload,
      });

      callback(type, payload);
    } else if (errorResponse == "Invalid or expired password reset token") {
      payload = "The password reset link has expired. Please generate new one";
      await dispatch({
        type,
        payload,
      });

      callback(type, payload);
    } else if (errorResponse.includes("This email is registered through")) {
      await dispatch({
        type,
        payload: errorResponse,
      });
    } else if (
      errorResponse ==
        "We were not able to process your latest payment for your subscription. Please check your payment method, if the issue still persists, please contact us." ||
      errorResponse ==
        "We were not able to process your payment for your subscription. Please check your payment method, if the issue still persists, please contact us." ||
      errorResponse ==
        "Something went wrong with your subscription. Please contact us to rectify this."
    ) {
      dispatch({ type, payload });
      openPaymentIssueModal(errorResponse)(dispatch);
    } else {
      payload = "Some error occured, please try again";
      dispatch({ type, payload });
    }
  }

  if (callback) await callback(type, payload);
};
